// @ts-check
import api from 'utils/api';

const actions = {
  fetchProfile(providerId) {
    return api
      .get(`/agent_portal/api/providers/${providerId}/profile`)
      .then(response => response.data);
  },
};

export default actions;
